import Component from '@glimmer/component'
import { service } from '@ember/service'
import { ThemeKeys, subscriptionTypeToThemeKey } from 'teacher-ui-client/utils/themes'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { on } from '@ember/modifier'
import { fn } from '@ember/helper'

interface Signature {
  Element: HTMLButtonElement
  Args: {
    filter: string
    label: string
    isActive: boolean
    toggleFilter: (filter: string) => void
  }
}

interface Theme {
  buttonBgColor?: string
  buttonBorderColor?: string
}
const themes: Partial<Record<ThemeKeys, Theme>> = {
  [ThemeKeys.blue]: {
    buttonBgColor:
      'bg-white hover:bg-oceany-blue-350 focus:bg-oceany-blue-350 aria-pressed:bg-oceany-blue-300 hover:aria-pressed:bg-oceany-blue-350 focus:aria-pressed:bg-oceany-blue-350 hover:text-white focus:text-white aria-pressed:text-white',
    buttonBorderColor: 'border border-oceany-blue-350',
  },
  [ThemeKeys.green]: {
    buttonBgColor:
      'bg-white hover:bg-ms-green-350 focus:bg-ms-green-350 aria-pressed:bg-ms-green-300 hover:aria-pressed:bg-ms-green-350 focus:aria-pressed:bg-ms-green-350 hover:text-white focus:text-white aria-pressed:text-white',
    buttonBorderColor: 'border border-ms-green-350',
  },
  [ThemeKeys.default]: {
    buttonBgColor:
      'bg-white hover:bg-black focus:bg-black aria-pressed:bg-black hover:aria-pressed:bg-black focus:aria-pressed:bg-black hover:text-white focus:text-white aria-pressed:text-white',
    buttonBorderColor: 'border border-black',
  },
}

export class QuickFilterButton extends Component<Signature> {
  @service subscriptionType!: SubscriptionTypeService

  get themeKey() {
    return subscriptionTypeToThemeKey(this.subscriptionType.current)
  }

  get selectedTheme() {
    return themes[this.themeKey] ?? themes[ThemeKeys.default]
  }

  <template>
    <button
      class="rounded-full p-3 {{this.selectedTheme.buttonBgColor}} {{this.selectedTheme.buttonBorderColor}}"
      type="button"
      aria-pressed={{if @isActive "true" "false"}}
      {{on "click" (fn @toggleFilter @filter)}}
      ...attributes
    >
      {{@label}}
      {{#if @isActive}}
        <div class="float-right ml-2">
          <PhosphorIcon @icon="phosphor-x-bold" />
        </div>
      {{/if}}
    </button>
  </template>
}
